import fullfilmentFilter from '../../pages/fullfillment/fullfilment.filter'
import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different regimen action types
*/
let initialstate = {
  isLoading: false,
  assignedDevices: [],
  filters: {},
  devices: [],
  assignedPlan: {},
  careplans: [],
}
export default function device_operations(state = { ...initialstate }, action) {
  //console.log(state);
  switch (action.type) {
    case ActionType.DEVICE_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.DEVICE_SET_ASSIGNED:
      return { ...state, assignedDevices: action.devices }
    case ActionType.PLAN_SET_ASSIGNED:
      return { ...state, assignedPlan: action.plan }
    case ActionType.DEVICE_SET_FILTERS:
      return { ...state, filters: action.filters }
    case ActionType.DEVICE_SET_DEVICE:
      return { ...state, devices: action.devices }
    case ActionType.DEVICE_SET_PLANS:
      return { ...state, careplans: action.careplans }
    case ActionType.DEVICE_SET_FULLFILLMENTS:
      return { ...state, ...action }
    case ActionType.DEVICE_SET_FULLFILLMENTS_COUNT:
      return { ...state, fullfillmentcount: action.fuifillmentCount }
    case ActionType.DEVICE_SET_FULLFILLMENT_DEVICES:
      return { ...state, fullfillmentDevices: action.fullfillmentDevices }
    case ActionType.DEVICE_LOCATION:
      return { ...state, location: action.deviceData.location,device: action.deviceData.device }  
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
